import { createContext } from 'react';

import { createUID } from '../../utils';

import type { MenuContextProps } from './Menu.types';

export default createContext<MenuContextProps>({
  mode: 'action',
  variant: 'drill-down',
  itemLayout: 'stacked',
  scrollAt: 7,
  loading: false,
  componentId: createUID(),
  pushFlyoutId: () => null,
  flyOutActiveIdStack: [],
  focusControl: null,
  updateActiveDescendants: () => null,
  setFocusDescendant: () => null,
  setFocusReturnEl: () => null,
  getScopedItemId: () => '',
  updateParentDescendantStack: () => null
});
